import { uniqueId } from "../../utils/index.js";
import { useMemo } from "react";
import { useField } from "react-final-form";
export const useQuiField = (name, config) => {
    var _a;
    const { input, meta } = useField(name, config);
    const id = useMemo(() => `qui-field-${uniqueId()}`, []);
    const errorMessage = (_a = meta === null || meta === void 0 ? void 0 : meta.error) !== null && _a !== void 0 ? _a : meta === null || meta === void 0 ? void 0 : meta.submitError;
    const showError = !!errorMessage && ((meta === null || meta === void 0 ? void 0 : meta.touched) || (meta === null || meta === void 0 ? void 0 : meta.submitFailed));
    return {
        inputProps: Object.assign(Object.assign({ id, invalid: showError }, input), { "aria-invalid": showError, "aria-describedby": `${id}-helper ${id}-subhelper ${id}-error` }),
        fieldProps: { id, showError, errorMessage },
    };
};
